import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Outlet } from "react-router-dom";

export default function MainLayout() {
    const [collapsed, setCollapsed] = useState(
        typeof window !== "undefined" ? window.innerWidth < 768 : false
    );
    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

    return (
        <div className="h-screen flex flex-col bg-gray-50 overflow-hidden">
            {/* HEADER */}
            <Header
                collapsed={collapsed}
                setCollapsed={setCollapsed}
                setMobileSidebarOpen={setMobileSidebarOpen}
            />

            {/* BODY */}
            <div className="flex flex-1 overflow-hidden">
                {/* SIDEBAR */}
                <Sidebar
                    collapsed={collapsed}
                    mobileOpen={mobileSidebarOpen}
                    onCloseMobile={() => setMobileSidebarOpen(false)}
                />

                {/* MAIN CONTENT */}
                <main
                    className="
                        flex-1 
                        relative            
                        overflow-y-auto 
                        bg-gray-50 
                        px-3 py-4
                        sm:px-4
                        lg:px-6 lg:py-6
                        custom-scrollbar"
                >
                    <div className="min-h-full pb-16">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}
